<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条：导出走权限按钮 handleExport，勿再写死一个导出避免重复。最后更新：2026-09-24 -->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
      </toolbar>

      <!--列表：主次层级 + 键值对齐，每列最多两行。最后修改：2026-08-07 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" @row-click="handleRowClick"
        ref="table" class="custom-tbl cplate-table" height="100%" style="width: 100%">
        <el-table-column type="selection" width="48" align="center"> </el-table-column>

        <el-table-column label="终端" min-width="140">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main" :title="scope.row.TerminalName">{{ scope.row.TerminalName || '-' }}</div>
              <div class="cell-meta" :title="scope.row.TerminalId">{{ scope.row.TerminalId || '-' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="归属" min-width="150">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main" :title="formatDepartmentName(scope.row)">{{ formatDepartmentName(scope.row) || '-' }}</div>
              <div class="cell-meta">{{ scope.row.CampusName || scope.row.campusName || '未设校区' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="位置" min-width="140">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main" :title="scope.row.AuthDeptName || scope.row.authDeptName">{{ scope.row.AuthDeptName || scope.row.authDeptName || '未授权班级' }}</div>
              <div class="cell-meta" :title="scope.row.Remarks || scope.row.remarks">{{ scope.row.Remarks || scope.row.remarks || '未填安装位置' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="96" align="center">
          <template slot-scope="scope">
            <div class="cell-block cell-block--center">
              <el-tag size="mini" class="status-tag" :type="scope.row.IsOnLine == 1 ? 'success' : 'info'" disable-transitions>
                {{ scope.row.IsOnLine == 1 ? '在线' : '离线' }}
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="能力" width="148" align="center">
          <template slot-scope="scope">
            <div class="cell-block cell-block--center">
              <div class="tag-row">
                <el-tag size="mini" :type="scope.row.IsPush ? 'success' : 'info'">{{ scope.row.IsPush ? '推送' : '不推送' }}</el-tag>
                <el-tag size="mini" :type="scope.row.IsAuthMEGVII ? 'success' : 'info'">{{ scope.row.IsAuthMEGVII ? '人脸开' : '人脸关' }}</el-tag>
              </div>
              <div class="cell-meta">{{ licenseTypeLabel(scope.row) || '未设授权' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="其它" min-width="160">
          <template slot-scope="scope">
            <div class="cell-block">
              <div class="cell-main">{{ scope.row.CreateTime || scope.row.createTime || '-' }}</div>
              <div class="cell-meta" :title="otherMetaText(scope.row)">{{ otherMetaText(scope.row) }}</div>
            </div>
          </template>
        </el-table-column>

      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page"
          :page-size="PageSize"
          :total="total"
          style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑团务设备" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">

          <el-form-item label="终端标识" prop="TerminalId">
            <el-input v-model="editForm.TerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="校区" prop="CampusId">
            <el-select v-model="editForm.CampusId" placeholder="请选择校区（可不选）" clearable filterable style="width: 100%">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="normalizeDeptId(item.Id)" />
            </el-select>
          </el-form-item>

          <!-- 添加管理员权限判断 -->
          <el-form-item v-if="isBlogAdmin" label="是否进行人脸授权" prop="IsAuthMEGVII">
            <el-switch v-model="editForm.IsAuthMEGVII" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>

          <el-form-item v-if="isBlogAdmin" label="授权方式" prop="LicenseType">
            <el-select v-model="editForm.LicenseType" placeholder="请选择授权方式" style="width: 100%">
              <el-option v-for="item in LicenseTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="editForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>
          <el-form-item label="安装位置">
            <el-input type="textarea" v-model="editForm.Remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增团务设备" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="终端标识" prop="TerminalId">
            <el-input v-model="addForm.TerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="校区" prop="CampusId">
            <el-select v-model="addForm.CampusId" placeholder="请选择校区（可不选）" clearable filterable style="width: 100%">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="normalizeDeptId(item.Id)" />
            </el-select>
          </el-form-item>

          <!-- 添加管理员权限判断 -->
          <el-form-item v-if="isBlogAdmin" label="是否进行人脸授权" prop="IsAuthMEGVII">
            <el-switch v-model="addForm.IsAuthMEGVII" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>

          <el-form-item v-if="isBlogAdmin" label="授权方式" prop="LicenseType">
            <el-select v-model="addForm.LicenseType" placeholder="请选择授权方式" style="width: 100%">
              <el-option v-for="item in LicenseTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="addForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>

          <el-form-item label="安装位置">
            <el-input type="textarea" v-model="addForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 指令下发模态框 -->
      <el-dialog title="下发指令" :visible.sync="commandDialogVisible" width="30%">
        <el-form :model="commandForm" label-width="80px">
          <el-form-item label="选择指令" prop="commandType">
            <el-select v-model="commandForm.commandType" placeholder="请选择指令">
              <el-option label="关机" value="shutdown"></el-option>
              <el-option label="重启" value="reboot"></el-option>
              <el-option label="更新H5" value="updateH5"></el-option>
              <el-option label="更新资源" value="resourceNotification"></el-option>
              <el-option label="更新人员" value="userChangeNotification"></el-option>
              <el-option label="增量更新人员" value="userAddNotification"></el-option>
              <el-option label="清除定时开关机" value="clearPowerOnOffTime"></el-option>
              <el-option v-if="isBlogAdmin" label="更新APK"
                value="updateApk"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="commandDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitCommand">确认下发</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { getCplateTerminalListPage, deleteCplateTerminal, batchDeleteCplateTerminal, editCplateTerminal, addCplateTerminal, authCplateTerminal, exportCplateTerminals } from '../../api/modules/attendance';
import { getSchoolDepartmentTree } from '../../api/modules/department';
import { getCampusList, batchDeviceCmd } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import superAdminMixin from '../../mixins/superAdminMixin'
import { getUnifiedPageSize } from '../../utils/elPaginationUnify'
import {
  normalizeDeptId as normalizeDeptIdUtil,
  treeNodeDeptId,
  resolveActiveSchoolId,
} from '../../utils/deptCascaderProps'

/** 团务考核设备业务类型（CplateTerminal.BizType = 1） */
const LEAGUE_AFFAIR_BIZ_TYPE = 1;

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
          placeholder: '终端名称'
        },
        {
          label: '序列号',
          key: 'terminalId',
          placeholder: '终端标识/序列号'
        },
        {
          label: '状态',
          key: 'isOnLine',
          type: 'select',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '在线', value: '1' },
            { label: '离线', value: '0' }
          ]
        },
      ],
      users: [],
      roles: [],
      campusOptions: [],
      total: 0,
      buttonList: [],
      page: 1,
      /** 与全站统一分页一致，避免 UI 写死 10 而请求被拦截器注入更大 pageSize 导致后页无数据。最后更新：2026-09-03 */
      PageSize: getUnifiedPageSize(),
      listLoading: false,
      exportLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        TerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],

        // 新增编辑验证规则
        IsAuthMEGVII: [
          { required: true, message: '请选择是否进行授权旷世', trigger: 'change' }
        ],
        LicenseType: [
          { required: true, message: '请选择授权方式', trigger: 'change' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        TerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        DepartmentId: 0,
        TerminalTypeId: "3",
        IsAuthMEGVII: false,
        LicenseType: '',
        Remarks: "",
        IsPush: false,
        CampusId: null,
        BizType: LEAGUE_AFFAIR_BIZ_TYPE,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        TerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],

        // 新增验证规则
        IsAuthMEGVII: [
          { required: true, message: '请选择是否进行授权旷世', trigger: 'change' }
        ],
        LicenseType: [
          { required: true, message: '请选择授权方式', trigger: 'change' }
        ],
      },
      //新增界面数据
      addForm: {
        TerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        DepartmentId: 0,
        TerminalTypeId: "3",
        IsAuthMEGVII: false,
        LicenseType: 'FACEPASS_AUTH_MCVSAFE',
        Remarks: "",
        IsPush: false,
        CampusId: null,
        BizType: LEAGUE_AFFAIR_BIZ_TYPE,
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      multipleSelection: [],
      LicenseTypeOptions: [
        { label: '一柒', value: 'FACEPASS_AUTH_ALGOMALL' },
        { label: '班牌厂家', value: 'FACEPASS_AUTH_MCVSAFE' },
      ],
      // 指令下发相关数据
      commandDialogVisible: false,
      commandForm: {
        commandType: ''
      },
      currentUser: null,
    };
  },
  computed: {
    /** 顶部学校下拉的学校 Id（字符串，避免雪花 Id 被 Number 截断）。最后修改：2026-10-18 */
    currentSchoolId() {
      return resolveActiveSchoolId(this) || ''
    },
  },
  methods: {

    //下发指令
    command() {
      // 检查是否选择了终端
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要操作的终端');
        return;
      }
      this.commandDialogVisible = true;
    },

    // 提交指令
    async submitCommand() {
      if (!this.commandForm.commandType) {
        this.$message.warning('请选择指令类型');
        return;
      }

      // 获取选中终端ID
      const terminalIds = this.multipleSelection.map(item => item.TerminalId);

      if (terminalIds.length === 0) {
        this.$message.warning('请选择至少一个终端');
        return;
      }

      var terminalId = terminalIds.join(',');

      this.submitLoading = true;
      try {

        var para = {
          serialNumbers: terminalId,
          commandType: this.commandForm.commandType
        }

        batchDeviceCmd(para).then((res) => {

          if (res.data.success) {
            this.$message.success(`成功下发${this.getCommandLabel(this.commandForm.commandType)}指令到${terminalIds.length}个终端`);
            this.commandDialogVisible = false;
          } else {
            // 将\n替换为<br>并启用HTML解析
            this.$message({
              message: `${res.data.msg ? res.data.msg.replace(/\n/g, '<br>') : '未知错误'}`,
              type: 'error',
              dangerouslyUseHTMLString: true
            });
          }
        });
      } catch (error) {
        this.$message.error(`接口调用失败: ${error.message}`);
      } finally {
        this.submitLoading = false;
      }
    },

    /** 向选中班牌下发旷视人脸授权配置。创建于 2025-08-18 */
    async CplateAuth() {
      try {
        await this.$confirm('确定要为选中班牌下发人脸授权吗？', '人脸授权', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 获取选中终端ID
        const terminalIds = this.multipleSelection.map(item => item.TerminalId);

        if (terminalIds.length === 0) {
          this.$message.warning('请选择至少一个终端');
          return;
        }

        var terminalId = terminalIds.join(',');

        this.submitLoading = true;

        var para = {
          serialNumbers: terminalId,
          commandType: this.commandForm.commandType
        }

        authCplateTerminal(para).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.commandDialogVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } catch (error) {
        // 用户取消授权操作
        if (error !== 'cancel') {
          this.$message.error(`接口调用失败: ${error.message}`);
        } else {
          this.$message({ type: 'info', message: '已取消人脸授权' });
        }
        return;
      } finally {
        this.submitLoading = false;
      }
    },

    // 获取指令显示名称
    getCommandLabel(type) {
      const labels = {
        'shutdown': '关机',
        'reboot': '重启',
        'updateH5': '更新H5',
        'resourceNotification': '更新资源',
        'userChangeNotification': '更新人员',
        'userAddNotification': '增量更新人员',
        'clearPowerOnOffTime': '清除定时开关机数据'
      };
      return labels[type] || type;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /** 点击行切换勾选（与勾选列行为一致） */
    handleRowClick(row, column, event) {
      if (column && column.type === 'selection') return
      if (event && event.target && typeof event.target.closest === 'function') {
        if (event.target.closest('.el-checkbox')) return
        if (event.target.closest('.op-link')) return
      }
      const isSelected = this.multipleSelection.some((item) => item.Id === row.Id)
      this.$refs.table.toggleRowSelection(row, !isSelected)
    },

    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      // 左侧学校树 Id 保持字符串。最后修改：2026-10-18
      this.DepartmentId = treeNodeDeptId(data)
      this.handleQuery();
      this.loadCampusOptions(this.DepartmentId);
      let para = {
        id: this.DepartmentId,
      };
    },

    /**
     * 拉取校区下拉（与 DutyStaff.loadCampusOptions 一致，接口 Campus/GetList）
     */
    loadCampusOptions(deptId) {
      const schoolOrDept = normalizeDeptIdUtil(deptId) || normalizeDeptIdUtil(this.DepartmentId);
      if (schoolOrDept) {
        return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolOrDept }).then((res) => {
          if (res.data.success) {
            this.campusOptions = res.data.response.data || [];
          }
        });
      }
      return getSchoolDepartmentTree({ pid: 0, type: 1 }).then((res) => {
        if (res.data.success && res.data.response) {
          return this.loadCampusOptions(res.data.response.value);
        }
      });
    },



    /** 未选校区用 null 展示；提交给接口时未选为 0，已选为 Id 字符串。最后修改：2026-10-18 */
    normalizeCampusIdForApi(val) {
      if (val == null || val === '' || val === 0 || val === '0') return 0;
      return normalizeDeptIdUtil(val) || 0;
    },

    /** 模板/el-option 用：校区 Id 字符串化。最后修改：2026-10-18 */
    normalizeDeptId(value) {
      return normalizeDeptIdUtil(value);
    },

    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    /** 部门展示：路径过长时只保留末两级 */
    formatDepartmentName(row) {
      const raw = (row && (row.DepartmentName || row.departmentName)) || ''
      if (!raw) return ''
      const parts = raw.split('/')
      if (parts.length > 2) return parts.slice(-2).join('/')
      return raw
    },

    /** 授权方式短文案 */
    licenseTypeLabel(row) {
      const t = row && (row.LicenseType != null ? row.LicenseType : row.licenseType)
      if (t === 'FACEPASS_AUTH_MCVSAFE') return '班牌厂家'
      if (t === 'FACEPASS_AUTH_ALGOMALL') return '一柒'
      return ''
    },

    /** 其它列次行：版本 · 备注 */
    otherMetaText(row) {
      const ver = (row && (row.Version || row.version)) || '-'
      const desc = (row && (row.TerminalDesc || row.terminalDesc)) || '-'
      return `版本 ${ver} · 备注 ${desc}`
    },

    /** 导出团务考核设备（固定 bizType=1） */
    async exportTerminals() {
      const params = {
        departmentId: this.DepartmentId,
        name: this.filters.name || '',
        terminalId: this.filters.terminalId || '',
        bizType: LEAGUE_AFFAIR_BIZ_TYPE
      }
      try {
        const response = await exportCplateTerminals(params)
        if (!response.data || response.data.size === 0) {
          this.$message.warning('暂无可导出的团务设备')
          return
        }
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `团务考核设备_${new Date().getTime()}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (error) {
        this.$message.error('导出失败')
      }
    },

    /** 权限按钮 Func=handleExport 入口 */
    handleExport() {
      return this.exportTerminals();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    /** 切换每页条数 */
    handleSizeChange(val) {
      this.PageSize = val;
      this.page = 1;
      this.handleQuery();
    },

    /** 分页查询团务考核设备列表（bizType=1） */
    handleQuery() {
      let para = {
        ...this.filters,
        page: this.page,
        intPageSize: this.PageSize,
        departmentId: this.DepartmentId,
        bizType: LEAGUE_AFFAIR_BIZ_TYPE,
      }
      this.listLoading = true;

      getCplateTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    /** 删除选中设备（支持批量，单次最多 10 条） */
    handleDel() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '请选择要删除的数据！',
          type: 'error',
        })
        return
      }
      if (rows.length > 10) {
        this.$message({
          message: '单次最多删除 10 条，请按页勾选后分批删除',
          type: 'error',
        })
        return
      }

      const tip = rows.length === 1
        ? '确认删除该记录吗?'
        : `确认批量删除选中的 ${rows.length} 台班牌终端吗?`

      this.$confirm(tip, "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          const ids = rows.map(r => r.Id).filter(id => id != null && id !== '')
          const req = ids.length === 1
            ? deleteCplateTerminal({ id: ids[0] })
            : batchDeleteCplateTerminal({ ids: ids.join(',') })
          req.then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg || "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }

      var row = rows[0];
      const rawCampus = normalizeDeptIdUtil(row.CampusId);
      const savedCampusId = rawCampus || null;

      this.options = [];

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      const schoolId = normalizeDeptIdUtil(row.DepartmentId) || normalizeDeptIdUtil(this.DepartmentId);
      this.editForm.DepartmentId = schoolId;
      this.editForm.CampusId = savedCampusId;
      this.editForm.BizType = LEAGUE_AFFAIR_BIZ_TYPE;
      this.loadCampusOptions(schoolId).then(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.editForm.CampusId = savedCampusId;
          }, 0);
        });
      });
    },
    //显示新增界面
    handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        TerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "1",
        TerminalDesc: "",
        DepartmentId: this.DepartmentId,
        TerminalTypeId: "3",
        IsAuthMEGVII: false,
        LicenseType: 'FACEPASS_AUTH_MCVSAFE',
        Remarks: "",
        IsPush: false,
        CampusId: null,
        BizType: LEAGUE_AFFAIR_BIZ_TYPE,
      };
      this.loadCampusOptions(this.DepartmentId);
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.CampusId = this.normalizeCampusIdForApi(para.CampusId);
            para.BizType = LEAGUE_AFFAIR_BIZ_TYPE;

            editCplateTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.CampusId = this.normalizeCampusIdForApi(para.CampusId);
            para.BizType = LEAGUE_AFFAIR_BIZ_TYPE;

            addCplateTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    // 格式化部门名称：只保留路径 of 最后两级
    formatDepartmentNameCol(row, column, cellValue) {
      if (!cellValue) return '';
      const parts = cellValue.split('/');
      if (parts.length > 2) {
        return parts.slice(-2).join('/');
      }
      return cellValue;
    },
  },
  mounted() {
    // 初始化当前用户信息
    if (window.localStorage.user) {
      this.currentUser = JSON.parse(window.localStorage.user);
    }
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let buttons = getButtonList(this.$route.path, routers);
    // 非超级管理员（admin / blogadmin）隐藏人脸授权按钮
    if (!this.isBlogAdmin) {
      this.buttonList = buttons.filter(btn => btn.Func !== 'CplateAuth');
    } else {
      this.buttonList = buttons;
    }
    // 权限库名称为「授权下发」，与班级授权易混淆，前端展示改为「人脸授权」
    this.buttonList = this.buttonList.map((btn) => (
      btn.Func === 'CplateAuth' ? { ...btn, name: '人脸授权' } : btn
    ));
    // 过滤掉话机/导入相关按钮（团务设备不需要）
    this.buttonList = this.buttonList.filter(btn =>
      btn.Func !== 'handleEnablePhone'
      && btn.Func !== 'ImportCensus'
      && btn.name !== '批量开通话机'
      && btn.name !== '开通话机'
      && btn.name !== '导入'
    );
  },
};
</script>

<style scoped>
/* 列表单元：主次两行、垂直居中对齐。最后修改：2026-08-07 */
.cell-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-height: 44px;
  padding: 2px 0;
}
.cell-block--center {
  align-items: center;
}
.cell-main {
  color: #303133;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-meta {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tag-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.status-tag {
  min-width: 64px;
  text-align: center;
}
.cplate-table >>> .op-link.el-button--text {
  padding: 4px 10px;
  margin: 0;
  border: none !important;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--btn-primary, #2563eb);
  background: transparent;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.cplate-table >>> .op-link.el-button--text:hover,
.cplate-table >>> .op-link.el-button--text:focus {
  color: var(--btn-primary-hover, #1d4ed8);
  background: rgba(37, 99, 235, 0.08);
  border: none !important;
  box-shadow: none;
  transform: none;
}
.cplate-table >>> .op-link.el-button--text.is-disabled,
.cplate-table >>> .op-link.el-button--text.is-disabled:hover,
.cplate-table >>> .op-link.el-button--text.is-disabled:focus {
  color: #c0c4cc;
  background: transparent;
  cursor: not-allowed;
}

/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.cplate-table >>> .el-table__body tr {
  cursor: pointer;
}

.cplate-table >>> .el-table td,
.cplate-table >>> .el-table th {
  vertical-align: middle;
}

.cplate-table >>> .el-table .cell {
  line-height: 20px;
  padding-left: 12px;
  padding-right: 12px;
}

.cplate-table >>> .el-tag--mini {
  height: 22px;
  line-height: 20px;
  padding: 0 8px;
}
.pi-preview-pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
